<div class="dialog-container">
  <span>
    <strong
      *ngIf="data?.type === alertTypes.PRIMARY else typeText"
      class="text-capitalize"
    >
    </strong>
    <ng-template #typeText>
      <strong
        class="text-capitalize">{{ data?.type === alertTypes?.DANGER ? 'error' : data?.type}}!
      </strong>
    </ng-template>
    <span class="message">{{data.message}}</span>
  </span>
  <mat-icon
    (click)="close()"
    class="material-icons-outlined close-icon"
  >close</mat-icon>
</div>
